module.exports = __webpack_public_path__ + "static/img/tunnel page top img_desktop.597e1a7c.jpg";